<template>
  <step-container heading="Invite User">
    <template v-slot:description>
      <p>Use same component as user modal to invite user</p>
    </template>

    <div class="flex flex-between flex-vertical-end mb-200">
      <form-field-input
        label="Email Address"
        type="email"
        class="mb-0 flex-grow"
        v-model="form.email_address"
      ></form-field-input>

      <form-field-select
        label="Is Owner"
        class="mb-0 mx-150"
        style="flex-basis: 120px"
        v-model="form.is_owner"
      >
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </form-field-select>

      <div class="mt-100 flex flex-end">
        <button-outlined @click="addUser">Invite User</button-outlined>
      </div>
    </div>

    <div class="flex-grow">
      <h3 class="has-text-weight-bold is-size-5 mb-100">Users to Invite:</h3>

      <template v-if="users.length">
        <step-item-user
          v-for="(user, index) in users"
          :key="index"
          :user="user"
        />
      </template>

      <p v-else class="mt-200 is-italic">There are no users to invite</p>
    </div>
  </step-container>
</template>

<script>
import {defineComponent} from 'vue'
import StepContainer from "../component/StepContainer.vue";
import StepItemUser from "../component/StepItemUser.vue";

export default defineComponent({
  name: "OnboardingStepInviteUser",
  components: {StepItemUser, StepContainer},
  data() {
    return {
      form: {
        email_address: null,
        is_owner: false,
      },
    }
  },
  computed: {
    users() {
      return this.$store.state.onboarding.provisionData.users;
    },
  },
  methods: {
    addUser() {
      this.$store.commit('onboarding/addUser', this.form);

      this.form = {
        email_address: null,
        is_owner: false,
      }
    },
  },
})
</script>

<style scoped lang="scss">

</style>
